import React from 'react';

export default function MMedusaCipher() {
    return (
        <React.Fragment>
            <div className="m-medusa">
                <div className="m-medusa-row">
                    <div className="m-medusa-left">KLOYKP</div>
                    <div className="m-medusa-right">
                        _ _ _ <span className="circle">_</span> _ _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">HDA</div>
                    <div className="m-medusa-right">
                        _ <span className="circle">_</span> _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">BNJOÍVKO</div>
                    <div className="m-medusa-right">
                        <span className="circle">_</span> _ _ _ _ _ _ _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">MIYLOOTGE</div>
                    <div className="m-medusa-right">
                        _ <span className="circle">_</span> _ _ _ _ _ _ _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">HRAÉ</div>
                    <div className="m-medusa-right">
                        _ _ <span className="circle">_</span> _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">HRIDNA</div>
                    <div className="m-medusa-right">
                        _ _ _ <span className="circle">_</span> _ _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">ATZÉL UONOR</div>
                    <div className="m-medusa-right">
                        _ _ _ _ _ &nbsp;&nbsp;&nbsp; _ _ _ <span className="circle">_</span> _
                    </div>
                </div>
                <div className="m-medusa-row">
                    <div className="m-medusa-left">TBROÁ</div>
                    <div className="m-medusa-right">
                        <span className="circle">_</span> _ _ _ _
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
